export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Card"] = "card";
    PaymentMethod["Invoice"] = "invoice";
})(PaymentMethod || (PaymentMethod = {}));
